/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'flexslider/jquery.flexslider-min';
import 'owlcarousel/owl-carousel/owl.carousel.min';

import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import MobileMenu from './components/tptnmobilemenu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/colorpicker';
import './lib/jquery.dcverticalmegamenu';
import './lib/jquery.scrollbox.min';
import './lib/tptnhtmlbox1';
import './components/block-cart';
import './components/tptnthemeconfig';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let mobileMenuEl = $('.mobile-menu ul');
  let dropDown = new DropDown(dropDownEl);
  let mobileMenu = new MobileMenu(mobileMenuEl);
  let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  dropDown.init();
  form.init();
  mobileMenu.init();
  productMinitature.init();
  productSelect.init();

  $('#mega-1').dcVerticalMegaMenu();

  $("#tptnhomeslider").flexslider({
    slideshow: $('#tptnhomeslider').data('play'),
    directionNav: true,
    controlNav: false,
    keyboardNav: true,
    slideshowSpeed: $('#tptnhomeslider').data('speed'),
    animationSpeed: 500,
    prevText: '<i class="material-icons">keyboard_arrow_left</i>',
    nextText: '<i class="material-icons">keyboard_arrow_right</i>'
  });
  
  $(".prodcrsl").owlCarousel({
    items : 4,
    itemsDesktop : [1182,4],
    itemsDesktopSmall : [974,3],
    itemsTablet: [750,2],
    itemsMobile : [622,1],
    slideSpeed : 500,
    rewindSpeed : 1000,
    autoPlay : false,
    stopOnHover : true,
    navigation : true,
    navigationText : ["",""],
    pagination : false,
    baseClass : "",
    theme : ""
  });

  $(".brandcrsl").owlCarousel({
    items : 4,
    itemsDesktop : [1182,4],
    itemsDesktopSmall : [974,3],
    itemsTablet: [750,3],
    itemsMobile : [622,2],
    slideSpeed : 500,
    rewindSpeed : 1000,
    autoPlay : false,
    stopOnHover : true,
    navigation : true,
    navigationText : ["",""],
    pagination : false,
    baseClass : "",
    theme : ""
  });

  $(".subcatcrsl").owlCarousel({
    items : 4,
    itemsDesktop : [1182,4],
    itemsDesktopSmall : [974,4],
    itemsTablet: [750,3],
    itemsMobile : [622,2],
    slideSpeed : 500,
    rewindSpeed : 1000,
    autoPlay : false,
    stopOnHover : true,
    navigation : true,
    navigationText : ["",""],
    pagination : false,
    baseClass : "",
    theme : ""
  });
});



// WEBPACK FOOTER //
// ./js/theme.js